import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckDouble = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15 4.96875C15.3125 5.28125 15.3125 5.75 15 6.03125L6.5 14.5312C6.375 14.6875 6.1875 14.75 6 14.75C5.78125 14.75 5.59375 14.6875 5.46875 14.5312L0.96875 10.0312C0.65625 9.75 0.65625 9.28125 0.96875 8.96875C1.25 8.6875 1.71875 8.6875 2 8.96875L6 12.9375L13.9688 4.96875C14.25 4.6875 14.7188 4.6875 15 4.96875ZM5.46875 7.53125L2.46875 4.53125C2.15625 4.25 2.15625 3.78125 2.46875 3.46875C2.75 3.1875 3.21875 3.1875 3.5 3.46875L6 5.9375L10.9688 0.96875C11.25 0.6875 11.7188 0.6875 12 0.96875C12.3125 1.28125 12.3125 1.75 12 2.03125L6.5 7.53125C6.375 7.6875 6.1875 7.75 6 7.75C5.78125 7.75 5.59375 7.6875 5.46875 7.53125Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgCheckDouble);
export { ForwardRef as ReactComponent };
